import { BaseFormSchema } from './form-schema';

export const defaultObservations: BaseFormSchema['observations'] = [
  {
    value:
      '<b>Open the floor for questions</b> and address any inquiries from the audience.',
  },
  {
    value:
      "<b>Outline next steps</b> for ongoing collaboration and future campaigns with LCI's expertise",
  },
];
